import { useEffect, useRef, useState } from "react";
import Button from "../button/button";

export default function ButtonDropdown({
    label = "Opções",
    title,
    iconLeft = "fa fa-cog",
    disabled,
    variant = "indigo",
    items = [],
    className
}) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    return (
        <div className="relative inline-block" ref={ref}>
            <Button
                type="button"
                variant={variant}
                disabled={disabled}
                title={title}
                className={className}
                iconLeft={iconLeft}
                iconRight="fa fa-chevron-down"
                label={label}
                onClick={() => setOpen(!open)}
            />

            {open && (
                <div className="absolute right-0 z-50 mt-2 w-60 surface-panel animate-in fade-in zoom-in-95 duration-150">
                    {items.map((item, index) => (
                        <button
                            key={index}
                            type="button"
                            disabled={item.disabled}
                            onClick={() => {
                                setOpen(false);
                                item.command?.();
                            }}
                            className="flex w-full items-center gap-3 px-4 py-2 text-sm text-foreground transition-colors duration-150 hover:bg-accent hover:text-accent-foreground disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {item.icon && (
                                <i className={`${item.icon} w-4 text-center`} />
                            )}

                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}